import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button, Modal, ProgressBar, Spinner } from "react-bootstrap";
import { saveAs } from "file-saver";

const CustomerExportModal = ({
  preheader = [],
  onShow,
  handleClose,
  exportCustomer,
  title = "Export Customer Details",
}) => {
  const [exportCSV, setExportCSV] = useState([]);
  const [dataReady, setDataReady] = useState(false);
  const [current, setCurrent] = useState(0);

  const processCSV = async (customers) => {
    let csvData = [];
    let count = 0;

    customers?.forEach((item) => {
      count++;
      csvData.push({
        name: item?.name || "N/A",
        point: item?.point || "N/A",
        phone: item?.phone || "N/A",
        status: item?.status || "N/A",
      });
    });

    setCurrent(count);
    setExportCSV(csvData);
    setDataReady(true);
  };

  useEffect(() => {
    if (exportCustomer?.length > 0) {
      processCSV(exportCustomer);
    }
  }, [exportCustomer]);

  const convertArrayOfObjectsToCSV = (array, preheader) => {
    if (!array || !array.length) return null;

    const headers = Object.keys(array[0]);
    const csvData = [
      ...preheader.map((row) => row.join(",")), // Add preheader rows
      headers.join(","), // Add header row
      ...array.map((row) =>
        headers
          .map((fieldName) => JSON.stringify(row[fieldName]) || "")
          .join(",")
      ),
    ];

    return csvData.join("\r\n");
  };

  const downloadCSV = () => {
    const csvString = convertArrayOfObjectsToCSV(exportCSV, preheader);
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const today = new Date();
    saveAs(blob, `Customer Details Export - [${today.toDateString()}].csv`);
  };

  return (
    <Modal show={onShow} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        {!dataReady ? (
          <div className="d-flex flex-column align-items-center">
            <Spinner animation="grow" variant="warning" size="sm" />
            <Icons.ClockOutline className="icon-trash text-warning" size={80} />
            <p className="text-dark mt-3 mb-3">
              <small>Please wait while your export is getting ready!</small>
            </p>
            <ProgressBar
              className="w-100"
              striped
              variant="success"
              now={
                current > 0
                  ? exportCustomer?.length > 0
                    ? Math.fround(
                        (100 / exportCustomer?.length) * current
                      )?.toFixed(2)
                    : 0
                  : 0
              }
              label={`${
                current > 0
                  ? exportCustomer?.length > 0
                    ? Math.fround(
                        (100 / exportCustomer?.length) * current
                      )?.toFixed(2)
                    : 0
                  : 0
              }%  - ${current} of ${exportCustomer?.length}`}
            />
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center">
            <Icons.CheckCircleOutline
              className="icon-trash text-success"
              size={100}
            />
            <p className="text-dark my-3">Your export is ready!</p>
            <Button className="btn btn-dark" onClick={downloadCSV}>
              <Icons.DownloadOutline
                className="icon-trash text-warning"
                size={22}
              />{" "}
              Download Customer Data
            </Button>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomerExportModal;
